import React, { Fragment } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Welcome from './Welcome';


const MainDashbord = () => {
    return (
        <Fragment>
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 className="page-title"> Perfil Especifico</h3>
                    </Col>
                </Row>
                <Row>
                    <Welcome />
                </Row>
            </Container>
        </Fragment>
    )
}

export default MainDashbord